import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/picture-pick/high_back.webp";

function Highlights() {
  return (
    <section
      className="intro_section p-100 high_pick"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#F44336" }}>Highlights</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              One of the best features of the app, aside from its
              rules-and-sequence implementation, is the automatic report
              generation for admin. This basically allows access to important
              information and statistics, such as, the number of people who
              viewed ads, played the game and total number of rewards that have
              been won and collected.
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-3"
          >
            <StaticImage
              src="../../../images/case-studies/picture-pick/highlights_img_1.png"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={1479}
              height={637}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
